
import CONSTANTS from '../constants'
import { getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'



export const getRateDetailsData = (TicketNum) => (dispatch) => {
  dispatch(addEventLog(TicketNum, CONSTANTS.EXTEND_CARD_DETAILS_REQUEST))
  dispatch({ type: CONSTANTS.EXTEND_CARD_DETAILS_REQUEST })
  let endpoint = `${APICONFIG.getExtendDetails}/${TicketNum}`
  let tobject = { TicketNum: TicketNum }
  return getRequest(endpoint).then((res) => {
    let resObject = { ...tobject, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.EXTEND_CARD_DETAILS_SUCCESS))
    dispatch({ type: CONSTANTS.EXTEND_CARD_DETAILS_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...tobject, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.EXTEND_CARD_DETAILS_FAILURE))
    dispatch({ type: CONSTANTS.EXTEND_CARD_DETAILS_FAILURE })
    return err
  })
}

export const getRateHourData = (payload) => (dispatch) => {
  let payloadGetRate = {...payload, 'device_type': 'web'}
  dispatch(addEventLog(payloadGetRate, CONSTANTS.EXTEND_CARD_HOUR_REQUEST))
  dispatch({ type: CONSTANTS.EXTEND_CARD_HOUR_REQUEST })
  return postRequest(APICONFIG.postExtendDays, payloadGetRate).then((res) => {
    let resObject = { ...payloadGetRate, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.EXTEND_CARD_HOUR_SUCCESS))
    dispatch({ type: CONSTANTS.EXTEND_CARD_HOUR_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payloadGetRate, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.EXTEND_CARD_HOUR_FAILURE))
    dispatch({ type: CONSTANTS.EXTEND_CARD_HOUR_FAILURE })
    return err
  })
}


export const postExtendData = (payload) => (dispatch) => {
  let payloadExtend = {...payload, 'device_type': 'web'}
  dispatch(addEventLog(payloadExtend, CONSTANTS.EXTEND_CARD_HOUR_REQUEST))
  dispatch({ type: CONSTANTS.EXTEND_CARD_HOUR_REQUEST })
  return postRequest(APICONFIG.postExtendSubmit, payloadExtend).then((res) => {
    let resObject = { ...payloadExtend, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.EXTEND_CARD_HOUR_SUCCESS))
    dispatch({ type: CONSTANTS.EXTEND_CARD_HOUR_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...payloadExtend, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.EXTEND_CARD_HOUR_FAILURE))
    dispatch({ type: CONSTANTS.EXTEND_CARD_HOUR_FAILURE })
    return err
  })
}



// EXTEND LIST
export const getExtendList = (ticket) => (dispatch) => {
  dispatch(addEventLog(ticket, CONSTANTS.EXTEND_TICKET_LIST_REQUEST))
  dispatch({ type: CONSTANTS.EXTEND_TICKET_LIST_REQUEST })
  let tobject = { ticket: ticket }
  return getRequest(`${APICONFIG.getExtendList}/${ticket}`).then((res) => {
    let resObject = { ...tobject, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.EXTEND_TICKET_LIST_SUCCESS))
    dispatch({ type: CONSTANTS.EXTEND_TICKET_LIST_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...tobject, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.EXTEND_TICKET_LIST_FAILURE))
    dispatch({ type: CONSTANTS.EXTEND_TICKET_LIST_FAILURE })
    return err
  })
}